import React from 'react'
import Footer from 'components/Footer'
import Header from './components/Header'
import Landing from './components/Landing'

export const App = () => {
  return (
    <div className="App">
      <Header />
      <Landing />
      <Footer />
    </div>
  )
}
